// Center Management page and its dialogs (center form, SMO overview, region
// management). Excel files and stored values ('Aktif' / 'İnaktif') stay Turkish.
const centers = {
  page: {
    title: 'Center Management',
    subtitle: 'Sites, SMO assignments and regional managers in one place.',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
    all: 'All',
  },
  common: {
    cancel: 'Cancel',
    close: 'Close',
  },
  actions: {
    add: 'New Center',
    regions: 'Region Management',
    regionsHint: 'Manage regions and regional managers on the map of Türkiye',
    smo: 'SMO Overview',
    smoHint: 'View the SMO assignments in detail',
    excel: 'Download Table',
    excelHint: 'Download every center with the visible columns as Excel',
  },
  stats: {
    total: 'Total Centers',
    totalShort: 'Total',
    active: 'Active Centers',
    activeShort: 'Active',
    inactive: 'Inactive Centers',
    inactiveShort: 'Inactive',
    share: '{{percent}}% of all centers',
  },
  toolbar: {
    search: 'Search by center name, province or district…',
    searchShort: 'Search centers…',
    status: 'Center status',
  },
  table: {
    listLabel: 'Center list',
    empty: 'No centers match the filters',
    rangeOf: 'of {{total}} centers',
    ofTotal: 'out of {{total}} in total',
    jump: 'Go to page',
    noRegion: 'No region assigned',
    noManager: 'No manager assigned',
    regionTitle: '{{region}}: {{managers}}',
  },
  columns: {
    name: 'Name',
    smo: 'SMO',
    smoBackup: 'Backup SMO',
    regionManager: 'Regional Manager',
    address: 'Address',
    info: 'Info',
    status: 'Status',
    city: 'Province',
    district: 'District',
    region: 'Region',
  },
  panel: {
    label: 'Selected center',
    heading: 'Center',
    edit: 'Edit',
    delete: 'Delete',
    deactivate: 'Set Inactive',
    activate: 'Set Active',
    toggleHint: 'Change status',
  },
  delete: {
    title: 'Delete Center',
    message: 'Are you sure you want to delete the center {{name}}?',
    usedTitle: 'Important',
    usedText: 'This center is used in the SMO Lead Reports. Even if you delete it, the data about this center in the SMO Lead Reports is kept.',
    irreversible: 'This cannot be undone.',
    confirm: 'Delete Center',
  },
  form: {
    titleAdd: 'Add New Center',
    titleEdit: 'Edit Center',
    subtitleAdd: 'Enter the location and the people responsible',
    sections: {
      basic: 'Center Details',
      people: 'People Responsible',
      notes: 'Address and Notes',
    },
    name: 'Name',
    city: 'Province',
    district: 'District',
    authority: 'Authorized Person',
    authorityHint: 'Chosen from the active external personnel.',
    smo: 'SMO',
    smoBackup: 'Backup SMO',
    peopleHint: 'The SMO and backup SMO are chosen from the active employees.',
    status: 'Status',
    address: 'Address',
    info: 'Info',
    choose: 'Please select',
    notInList: '{{name}} (not in the active list)',
    reset: 'Reset',
    add: 'Add',
    update: 'Update',
    processing: 'Processing…',
  },
  smo: {
    title: 'SMO Overview',
    subtitle: 'See which employee is the SMO of which center',
    stats: {
      smoCount: 'Total SMOs',
      withSmo: 'Centers with SMO',
      active: 'Active Centers',
      orphan: 'Centers without SMO',
      average: 'Avg. Centers / SMO',
    },
    search: 'Search SMO name, center, province or district…',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    excel: 'Excel',
    excelHint: 'Download the SMO assignments as Excel',
    empty: 'No results',
    centerCount_one: '{{count}} center',
    centerCount_other: '{{count}} centers',
    activeCount: '{{count}} active',
    inactiveCount: '{{count}} inactive',
    workerCount_one: '{{count}} employee',
    workerCount_other: '{{count}} employees',
    workersHint: 'Employees assigned to this center in projects',
    noLocation: 'No location given',
    removeHint: 'Remove the SMO assignment from this center',
    showEmployees: 'Show the employees of this center',
    employeesTitle: 'Employees at this center ({{count}})',
    orphanTitle: 'Centers Without an SMO',
    orphanCount_one: '{{count}} center is waiting for an SMO',
    orphanCount_other: '{{count}} centers are waiting for an SMO',
    remove: {
      title: 'Remove SMO Assignment',
      lead: 'Are you sure you want to remove {{smo}} as the SMO of {{center}}?',
      whatTitle: 'What happens?',
      itemSmo: 'The SMO assignment of this center is cleared and no SMO is shown for it on the SMO Lead Reports page.',
      itemKept: 'The center, employees, visits, calendar and Manual Data Entry records are kept. Only the SMO assignment is removed.',
      itemLater: 'You can assign a new SMO to this center later.',
      confirm: 'Remove SMO Assignment',
      removing: 'Removing…',
    },
  },
  regions: {
    title: 'Region Management',
    subtitle: 'Assign provinces to regions on the map and set regional and provincial managers',
    hintSelected: 'Click provinces on the map to add them to / remove them from {{region}}',
    hintNone: 'Select a region, then click provinces on the map to assign them',
    assigned: '{{count}} / 81 provinces assigned',
    regionCount_one: '{{count}} region',
    regionCount_other: '{{count}} regions',
    listTitle: 'Regions',
    add: 'New Region',
    loading: 'Loading…',
    empty: 'No regions yet. Start with "New Region".',
    color: 'Region color',
    namePlaceholder: 'Region name',
    delete: 'Delete region',
    managerPlaceholder: 'Select the regional manager',
    noCities: 'No provinces assigned',
    cityHint: 'Manage the managers of this province',
    cityManagerCount_one: '{{count}} provincial manager',
    cityManagerCount_other: '{{count}} provincial managers',
    cityManagers: 'Managers of {{city}}',
    managerCount_one: '{{count}} manager',
    managerCount_other: '{{count}} managers',
    noCityManagers: 'No province-specific assignment',
    fallback: 'The regional manager is used: {{name}}',
    noneYet: 'No manager assigned to this province yet',
    removeManager: 'Remove manager',
    noMoreManagers: 'No more managers to add',
    addManager: 'Add manager',
    pickCity: 'Select a province above to add province-specific managers.',
    centers_one: '{{count}} center',
    centers_other: '{{count}} centers',
    workers_one: '{{count}} employee',
    workers_other: '{{count}} employees',
    projects_one: '{{count}} project',
    projects_other: '{{count}} projects',
    centersHint: 'Number of centers in the region',
    workersHint: 'Number of employees at the centers of the region',
    projectsHint: 'Number of projects running at the centers of the region',
    showCenters: 'Show center details',
    hideCenters: 'Hide center details',
    centerMeta: 'Employees: {{workers}} · Projects: {{projects}}',
    save: 'Save',
    saving: 'Saving…',
    map: {
      label: 'Region map of Türkiye',
      manager: 'Regional Manager: {{names}}',
      unassigned: 'No region assigned',
      summary: 'Centers: {{centers}} · Employees: {{workers}} · Projects: {{projects}}',
      centerLine: '{{name}} — employees: {{workers}}, projects: {{projects}}',
      more_one: '+ {{count}} more center',
      more_other: '+ {{count}} more centers',
    },
  },
  toast: {
    loadError: 'Centers could not be loaded',
    excelDone: 'Excel file downloaded',
    excelError: 'The file could not be downloaded',
    statusUpdated: 'Center status set to {{status}}',
    statusError: 'The status could not be updated',
    checkError: 'The center could not be checked',
    deleted_one: 'Center deleted. {{count}} employee record updated.',
    deleted_other: 'Center deleted. {{count}} employee records updated.',
    deleteError: 'The center could not be deleted',
    added: 'New center added',
    addError: 'The center could not be added',
    updated: 'Center updated!',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
    employeesError: 'Employees could not be loaded',
    authoritiesError: 'Authorized persons could not be loaded',
    formAdded: 'Center added!',
    formUpdateError: 'The center could not be updated!',
    formAddError: 'The center could not be added!',
    smoExcelDone: 'Excel file downloaded',
    smoExcelError: 'The Excel file could not be downloaded',
    smoRemoved: 'SMO assignment removed.',
    smoRemovedCount_one: 'SMO assignment removed. {{count}} record cleared in {{projects}} project(s).',
    smoRemovedCount_other: 'SMO assignment removed. {{count}} records cleared in {{projects}} project(s).',
    smoRemoveError: 'The SMO could not be removed',
    regionsLoadError: 'Regions could not be loaded',
    pickRegionFirst: 'First select a region in the region list or add a new one',
    regionNameRequired: 'Give every region a name',
    regionsSaved: 'Regions saved',
    regionsSaveError: 'The regions could not be saved',
  },
};

export default centers;
